<template>
    <v-container class="ma-0 pa-0 pb-8">
        <div class="pt-6 px-8 pb-6">
            <v-row class="ma-0 mb-2">
                <strong>Filtros</strong>
                <v-spacer></v-spacer>
                <v-btn @click="clearFilters" small class="elevation-0" style="border:solid 1px #dddddd;">
                <v-icon small class="mr-1">mdi-filter-off</v-icon> Limpiar
                </v-btn>
            </v-row>

            <v-autocomplete
                v-model="filters.provider_id"
                :items="providerLists"
                hide-no-data
                item-value="id"
                item-text="name"
                label="Proveedor(es)"
                placeholder="Escribe para buscar"
                attach
                chips
                multiple
            />

            <v-menu offset-y :close-on-content-click="closeDatePicker(filters.dateRange)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field  clearable  v-model="filters.dateRange" label="Fecha" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="filters.dateRange" range></v-date-picker>
            </v-menu>

            <v-text-field @keydown.enter="applyFilters()" v-model="filters.id" label="Id"></v-text-field>

            <v-select v-model="filters.paid" clearable :items="paid" item-text="label" item-value="value" label="Pagado"></v-select>

            <v-menu offset-y :close-on-content-click="closeDatePicker(filters.dueDateRange)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field  clearable  v-model="filters.dueDateRange" label="Fecha Vencimiento" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="filters.dueDateRange" range></v-date-picker>
            </v-menu>

            <v-select v-model="filters.serie" clearable :items="series" label="Serie"></v-select>

            <v-text-field @keydown.enter="applyFilters()" v-model="filters.invoice" label="Factura"></v-text-field>

            

            <!--v-autocomplete @keydown.enter="filter()" v-model="shopping.item_id" :items="itemsList" item-text="name" item-value="id" attach chips label="Producto" multiple>
                <template slot="no-data" class="pa-2">No existen productos relacionados.</template>  
            </v-autocomplete-->

            <!--v-autocomplete @keydown.enter="filter()" v-model="shopping.user_id" :items="userLists" item-text="name" item-value="id" attach chips label="Vendedor" multiple>
                <template slot="no-data" class="pa-2">No existen usuarios relacionados.</template>  
            </v-autocomplete-->

            <v-text-field
                v-model="filters.note"
                label="Descripción"
            />

        </div>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
            <v-list-item link @click="applyFilters" dark>
                <v-list-item-content>
                    <strong>Filtrar ({{ activeFiltersCount }})</strong>
                </v-list-item-content>
            </v-list-item>
        </v-card>
    </v-container>
</template>
<script>
  export default {
    data: () => ({
        paid:[{label:'No', value:'false'}, {label:'Si', value:'true'}],
        series:['Serie A', 'Serie B', 'Inversiones'],
        filters:{
            id:'',
            dateRange:[],
            dueDateRange:[],
            notes:'',
            provider_id: [],
            invoice:'',
            serie:'',
            paid:'',
        },
        itemsList:[],
        isLoadingItems:false,
        searchItems:'',
        menuDate: false
    }),
    watch:{
        searchItems: {
            handler() {
                this.isLoadingItems = true;
                const searchTerm = this.searchItems.trim();
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/item/pos?filter[pos]=' + searchTerm + '&itemsPerPage=15')
                .then(response => {
                    if (this.searchItems === searchTerm) {
                        this.itemsList = response.data.data.map(id => ({
                            id: id.id,
                            name: id.name
                        }));
                        this.isLoadingItems = false;
                    }
                })
            },
            deep: true
        },
    },
    computed: { 
        userLists(){
            return this.$store.state.user.users;
        }, 
        providerLists(){
            return this.$store.state.provider.providers;
        },
        activeFiltersCount() {
            let c = 0;

            if (this.filters.id?.length) c++;
            if (this.filters.dateRange?.length) c++;
            if (this.filters.dueDateRange?.length) c++;
            if (this.filters.notes?.length) c++;
            if (this.filters.provider_id?.length) c++;
            if (this.filters.invoice?.length) c++;
            if (this.filters.serie?.length) c++;
            if (this.filters.paid?.length) c++;

            return c;
        },
    },
    created () {
        const saved = localStorage.getItem("shoppingFilters");
        if (saved) {
            this.filters = JSON.parse(saved);
            this.emitFilters();
        }
    },
    methods: {
        closeDatePicker(dates){
            if(dates!=undefined && dates.length==2){
                return true
            }else{
                return false
            }
        },
        applyFilters() {
            localStorage.setItem("shoppingFilters", JSON.stringify(this.filters));
            this.emitFilters();
        },
        clearFilters() {
            this.filters = {
                id:'',
                dateRange:[],
                dueDateRange:[],
                notes:'',
                provider_id: [],
                invoice:'',
                serie:'',
                paid:'',
            };
            localStorage.removeItem("shoppingFilters");
            this.emitFilters();
        },
        emitFilters() {
            const params = {};

            for (const [key, value] of Object.entries(this.filters)) {
                if (Array.isArray(value) && value.length > 0) {
                    params[`filter[${key}]`] = value.join(',');
                } else if (typeof value === 'string' && value.trim() !== '') {
                    params[`filter[${key}]`] = value.trim();
                } else if (value && typeof value === 'object' && Object.keys(value).length > 0) {
                    params[`filter[${key}]`] = JSON.stringify(value);
                }
            }

            this.$emit("filters", params, this.activeFiltersCount);
        },
    }
  }
</script>